import NamedDto from 'modules/base/dto/NamedDto';
import DatasetFieldEditDto from './DatasetFieldEditDto';

export class DatasetEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.description = null;
		/** @type {DatasetFieldEditDto[]} */
		this.keyFields = null;
		/** @type {DatasetFieldEditDto[]} */
		this.valueFields = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _DatasetEditDtoProps
	 * @property {string} description
	 * @property {DatasetFieldEditDto[]} keyFields
	 * @property {DatasetFieldEditDto[]} valueFields
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DatasetEditDtoProps} DatasetEditDtoProps
	 */
	/**
	 *
	 * @param {DatasetEditDtoProps} props
	 * @returns {DatasetEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.description = props.description;
		this.keyFields = props.keyFields !== null ? props.keyFields.map(d => new DatasetFieldEditDto().setup(d)) : [];
		this.valueFields = props.valueFields !== null ? props.valueFields.map(d => new DatasetFieldEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;
		return this;
	}
}

export default DatasetEditDto;
